import React, { useState } from 'react';
import './VedaGurukulam.css';
import vedaHeroImage from '../vedaHero.png';
import veda1Image from '../veda1.jpeg';
import veda2Image from '../veda2.jpeg';
import purpose1Image from '../purpose1.png';
import purpose2Image from '../purpose2.png';
import purpose3Image from '../purpose3.png';
import purpose4Image from '../purpose4.png';
import fig1Icon from '../fig1.png';
import fig2Icon from '../fig2.png';
import fig3Icon from '../fig3.png';
import fig4Icon from '../fig4.png';
import fig5Icon from '../fig5.png';
import fig6Icon from '../fig6.png';
import fig7Icon from '../fig7.png';
import arrowUpIcon from '../arrow-up.png';
import Contact from '../components/Contact';


const VedaGurukulam = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqData = [
    {
      id: 1,
      question: "Are gurukuls only for religious families?",
      answer: "No, gurukuls welcome students from all backgrounds. While they emphasize spiritual values and traditional learning, families from diverse backgrounds can benefit from the holistic education, discipline, and character development that gurukuls provide. The focus is on universal human values rather than specific religious practices."
    },
    {
      id: 2,
      question: "Will my child be able to compete in modern careers after gurukul education?",
      answer: "Yes, gurukul education develops strong foundational skills including discipline, critical thinking, memory, and ethical values that are highly valued in modern careers. Many gurukuls also incorporate contemporary subjects alongside traditional learning. The character development and leadership qualities fostered in gurukuls often give students an advantage in their professional lives."
    },
    {
      id: 3,
      question: "What's the typical age for admission?",
      answer: "Most gurukuls accept students between ages 8-14 years, though some may have different age ranges. The ideal age is often considered to be around 8-10 years when children are most receptive to learning and can adapt well to the gurukul environment. However, each gurukul may have its own specific admission criteria and age requirements."
    },
    {
      id: 4,
      question: "How much does it cost to attend a gurukul?",
      answer: "Costs vary significantly between different gurukuls. Many traditional gurukuls operate on the principle of 'Guru Dakshina' where education is provided freely or at minimal cost, with families contributing according to their capacity. Some modern gurukuls may have structured fee systems. It's best to contact the specific gurukul directly for detailed fee information."
    },
    {
      id: 5,
      question: "Can students switch from gurukul back to regular school?",
      answer: "Yes, students can transition back to regular schools, though it may require some adjustment. Many gurukuls help facilitate this transition by providing necessary documentation and academic records. The strong foundation in discipline, values, and learning methods often helps students adapt well to different educational environments."
    },
    {
      id: 6,
      question: "Do gurukuls have modern facilities like computer labs?",
      answer: "This varies by gurukul. While traditional gurukuls focus primarily on classical learning methods, many modern gurukuls have incorporated contemporary facilities including computer labs, science laboratories, and modern infrastructure while maintaining their core traditional values and teaching methods. The balance between traditional and modern facilities depends on each gurukul's philosophy and resources."
    }
  ];

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };
  return (
    <div className="veda-gurukulam-page">
      {/* Hero Section */}
      <section className="veda-hero-section">
        <div className="veda-hero-overlay">
          <div className="veda-hero-content">
            <h1 className="veda-hero-title">
              <span className="veda-title-line-1">Veda</span>
              <span className="veda-title-line-2">Gurukulam</span>
            </h1>
          </div>
        </div>
      </section>

      {/* Sri Veda Gurukulam Section */}
      <section className="sri-veda-section">
        <div className="container">
          <div className="sri-veda-content">
            <div className="sri-veda-text">
              <div className="sri-veda-header">
                <h2 className="sri-veda-title">Sri Veda Gurukulam</h2>
              </div>
              
              <p className="sri-veda-description">
                Veda Gurukulam is the heart of Sri Veda Gurukulam, where ancient Vedic 
                knowledge is preserved and transmitted through the authentic Guru-
                Shishya Parampara. It is a sacred environment where learning, discipline, 
                devotion, and daily life unite, guiding students on a holistic spiritual and 
                educational journey rooted in Sanatana Dharma.
              </p>
              
              <p className="sri-veda-description">
                Within the Gurukulam, education goes beyond academic instruction and 
                becomes a way of life. Students live in close association with their 
                Acharyas, learning through disciplined routines, oral transmission, 
                constant practice, and personal guidance. Emphasis is placed on purity 
                of chanting, depth of understanding, and practical application of Vedic 
                teachings. Through this immersive approach, students develop spiritual 
                awareness, moral strength, and a deep sense of responsibility to uphold 
                Dharma and serve society as torchbearers of Vedic tradition.
              </p>
            </div>
            
            <div className="sri-veda-image">
              <div className="image-caption">
                <h3 className="image-caption-title">A Sacred Space for Living and Learning Vedic Wisdom</h3>
              </div>
              <img src={veda1Image} alt="A Sacred Space for Living and Learning Vedic Wisdom" />
              
            </div>
          </div>
        </div>
      </section>

      {/* What is Veda Gurukulam Section */}
      <section className="what-veda-section">
        <div className="container">
          <div className="what-veda-content">
            <div className="what-veda-image">
              <img src={veda2Image} alt="Understanding the Gurukul System" />
            </div>
            
            <div className="what-veda-text">
              <div className="what-veda-header">
                <h2 className="what-veda-title">What is Veda Gurukulam ?</h2>
              </div>
              
              <div className="understanding-section">
                <h3 className="understanding-title">Understanding the Gurukul System</h3>
                
                <p className="what-veda-description">
                  The Veda Gurukulam is an ancient system of education where students 
                  live in close association with the Guru and learn through observation, 
                  practice, and disciplined living. Knowledge is imparted orally and 
                  reinforced through daily repetition, spiritual practices, and service. This 
                  immersive approach ensures that learning is deeply rooted, precise, and 
                  preserved in its purest form, as passed down through generations.
                </p>
                
                <p className="what-veda-description">
                  Unlike modern education systems that focus primarily on information 
                  transfer, the Gurukul system emphasizes character formation, spiritual 
                  maturity, and experiential understanding. Students are trained not only 
                  in sacred texts but also in values such as humility, self-discipline, 
                  respect, and responsibility. Learning takes place throughout the day—
                  during chanting sessions, rituals, daily duties, and interactions with the 
                  Guru—making education a continuous and living process. Through this 
                  holistic method, the Veda Gurukulam nurtures individuals who embody 
                  Vedic wisdom in thought, conduct, and service to society.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Purpose Of Veda Gurukulam Section */}
      <section className="purpose-veda-section">
        <div className="container">
          <div className="purpose-veda-content">
            <div className="purpose-veda-header">
              <h2 className="purpose-veda-title">Purpose Of Veda Gurukulam</h2>
            </div>
            
            <div className="purpose-main-section">
              <h3 className="purpose-subtitle">Our Purpose</h3>
              
              <p className="purpose-description">
                The purpose of Veda Gurukulam is to safeguard and transmit the timeless wisdom of the Vedas through authentic traditional practices. Rooted in 
                the Guru-Shishya Parampara, the Gurukulam is committed to preserving the purity, accuracy, and spiritual essence of Vedic traditions for future 
                generations.
              </p>
              
              <ul className="purpose-list">
                <li>To preserve the purity and authenticity of Vedic knowledge and traditions without dilution</li>
                <li>To train students in accurate Vedic chanting, rituals, and sacred practices following classical methods</li>
                <li>To nurture disciplined, value-based individuals grounded in humility, devotion, and ethical living</li>
                <li>To prepare students to serve society through Dharma, spiritual leadership, and selfless service</li>
              </ul>
              
              <p className="purpose-conclusion">
                Through this purpose, Veda Gurukulam aims to shape individuals who not only possess deep Vedic knowledge but also live by its principles in 
                thought, action, and service to humanity.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Purpose Gallery Section */}
      <section className="purpose-gallery-section">
        <div className="container">
          <div className="purpose-gallery-content">
            <div className="purpose-gallery-header">
              <div className="header-top-row">
                <div className="header-left">
                  <h2 className="purpose-gallery-title">Vedic Knowledge Imparted</h2>
                  <div className="title-underline"></div>
                </div>
                <div className="header-right">
                  <h3 className="purpose-gallery-subtitle">The Sampradayam Of Adhyayanam</h3>
                </div>
              </div>
            </div>
            
            <div className="purpose-gallery-description">
              <p>
                Students are trained in the study of the Rig Veda, Yajur Veda, Sama Veda, and Atharva Veda, with strong emphasis on precise pronunciation, 
                correct swara (intonation), rhythm, and disciplined memorization. Learning follows the traditional oral method, ensuring the purity, accuracy, and 
                continuity of Vedic recitation as preserved through generations.
              </p>
            </div>

            <div className="rig-veda-section">
              <div className="rig-veda-image">
                <img src={purpose1Image} alt="Rig Veda" />
              </div>
              <div className="rig-veda-content">
                <h4 className="rig-veda-title">Rig Veda</h4>
                <p className="rig-veda-description">
                  Verily, the Rig Veda is regarded as the source and foundation of all Vedic 
                  knowledge. When Sage Vedavyasa compiled and classified the Vedas, 
                  he first took up the Rig Veda, acknowledging its primacy and spiritual 
                  depth. The word Rig is derived from the Sanskrit root Rik, meaning "to 
                  invoke" or "to praise the divine," originating from Ruchastutau (रुच स्तुतौ). 
                  The Rig Veda consists of sacred hymns dedicated to various deities, 
                  expressing devotion, cosmic order (Rta), and universal harmony. 
                  Through precise chanting and contemplation, it awakens spiritual 
                  awareness and forms the basis for Vedic rituals, philosophy, and the 
                  understanding of Dharma.
                </p>
              </div>
            </div>

            <div className="yajur-veda-section">
              <div className="yajur-veda-content">
                <h4 className="yajur-veda-title">Yajur Veda</h4>
                <p className="yajur-veda-description">
                  The Yajur Veda is the second of the four Vedas and serves as the 
                  practical guide for Vedic rituals and sacrificial ceremonies. It is divided 
                  into two major branches: the Shukla Yajur Veda and the Krishna Yajur 
                  Veda. Every Veda consists of two essential components—Mantra and 
                  Brahmana, with the Upanishads forming part of the Brahmana literature. 
                  In the Krishna Yajur Veda, the mantras and their explanatory Brahmanas 
                  are presented together in an integrated form. In contrast, the Shukla 
                  Yajur Veda distinctly separates the mantras from the Brahmana texts, 
                  offering a systematic and structured approach to ritual performance 
                  and understanding.
                </p>
              </div>
              <div className="yajur-veda-image">
                <img src={purpose2Image} alt="Yajur Veda" />
              </div>
            </div>

            <div className="sama-veda-section">
              <div className="sama-veda-image">
                <img src={purpose3Image} alt="Sama Veda" />
              </div>
              <div className="sama-veda-content">
                <h4 className="sama-veda-title">Sama Veda</h4>
                <p className="sama-veda-description">
                  The Sama Veda holds a unique place among the Vedas as the 
                  foundation of Vedic music and melodic chanting. A group of mantras is 
                  referred to as Samhita, while their detailed explanations are contained 
                  in the Brahmana section of the Veda. The Sama Veda is divided into two 
                  primary parts: Mantra Samhita and Gaana Samhita. The Mantra Samhita 
                  is further classified into Purvarchik and Uttararchik. The Purvarchik is 
                  subdivided into Veyagana and Aranyagana, each prescribing specific 
                  melodic patterns. Through disciplined chanting and musical intonation, 
                  the Sama Veda elevates ritual worship, inner harmony, and spiritual 
                  realization.
                </p>
              </div>
            </div>

            <div className="atharva-veda-section">
              <div className="atharva-veda-content">
                <h4 className="atharva-veda-title">Atharva Veda</h4>
                <p className="atharva-veda-description">
                  The Atharva Veda Samhita is the fourth of the four Vedas and is also 
                  known as the Brahma Veda. In this context, Samhita refers to a 
                  structured collection of sacred mantras. The Atharva Veda contains 
                  invocations and praises addressed to various deities, along with 
                  profound insights into human life and well-being. It is unique among the 
                  Vedas for its emphasis on practical knowledge and curative science. 
                  The Atharva Veda includes mantras intended for healing physical and 
                  mental ailments, promoting peace, harmony, and protection. Through its 
                  verses, it addresses everyday concerns while guiding individuals toward 
                  spiritual balance and holistic wellness.
                </p>
              </div>
              <div className="atharva-veda-image">
                <img src={purpose4Image} alt="Atharva Veda" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* A Day at a Gurukul Section */}
      <section className="gurukul-day-section">
        <div className="container">
          <div className="gurukul-day-content">
            <div className="gurukul-day-header">
              <div className="gurukul-day-line"></div>
              <h2 className="gurukul-day-title">A Day at a Gurukul</h2>
            </div>
            
            <div className="gurukul-day-subtitle">
              <p>
                Structured yet flexible—balancing 
                academics, wellness, skills, and 
                spirituality
              </p>
            </div>

            <div className="gurukul-timeline">
              <div className="timeline-line"></div>
              
              <div className="timeline-item left">
                <div className="timeline-content">
                  <div className="timeline-header">
                    <div className="timeline-icon">
                      <img src={fig1Icon} alt="Morning Meditation" />
                    </div>
                    <div className="timeline-time">5:30 AM</div>
                  </div>
                  <h4 className="timeline-title">Morning Meditation & Yoga</h4>
                  <p className="timeline-description">Day begins with pranayama, meditation, and surya namaska</p>
                </div>
                <div className="timeline-dot"></div>
              </div>

              <div className="timeline-item right">
                <div className="timeline-content">
                  <div className="timeline-header">
                    <div className="timeline-icon">
                      <img src={fig2Icon} alt="Academic Classes" />
                    </div>
                    <div className="timeline-time">7:00 AM</div>
                  </div>
                  <h4 className="timeline-title">Academic Classes</h4>
                  <p className="timeline-description">Mathematics, sciences, languages, and Vedic studies</p>
                </div>
                <div className="timeline-dot"></div>
              </div>

              <div className="timeline-item left">
                <div className="timeline-content">
                  <div className="timeline-header">
                    <div className="timeline-icon">
                      <img src={fig3Icon} alt="Lunch & Community" />
                    </div>
                    <div className="timeline-time">12:00 PM</div>
                  </div>
                  <h4 className="timeline-title">Lunch & Community Time</h4>
                  <p className="timeline-description">Nutritious vegetarian meals prepared collectively</p>
                </div>
                <div className="timeline-dot"></div>
              </div>

              <div className="timeline-item right">
                <div className="timeline-content">
                  <div className="timeline-header">
                    <div className="timeline-icon">
                      <img src={fig4Icon} alt="Skill Development" />
                    </div>
                    <div className="timeline-time">2:00 PM</div>
                  </div>
                  <h4 className="timeline-title">Skill Development</h4>
                  <p className="timeline-description">Arts, music, pottery, farming, or traditional crafts</p>
                </div>
                <div className="timeline-dot"></div>
              </div>

              <div className="timeline-item left">
                <div className="timeline-content">
                  <div className="timeline-header">
                    <div className="timeline-icon">
                      <img src={fig5Icon} alt="Sports & Activities" />
                    </div>
                    <div className="timeline-time">4:30 PM</div>
                  </div>
                  <h4 className="timeline-title">Sports & Physical Activities</h4>
                  <p className="timeline-description">Outdoor games, martial arts, or nature walks</p>
                </div>
                <div className="timeline-dot"></div>
              </div>

              <div className="timeline-item right">
                <div className="timeline-content">
                  <div className="timeline-header">
                    <div className="timeline-icon">
                      <img src={fig6Icon} alt="Satsang & Study" />
                    </div>
                    <div className="timeline-time">6:00 PM</div>
                  </div>
                  <h4 className="timeline-title">Satsang & Study</h4>
                  <p className="timeline-description">Group discussions, homework, and cultural activities</p>
                </div>
                <div className="timeline-dot"></div>
              </div>

              <div className="timeline-item left">
                <div className="timeline-content">
                  <div className="timeline-header">
                    <div className="timeline-icon">
                      <img src={fig7Icon} alt="Rest & Reflection" />
                    </div>
                    <div className="timeline-time">9:00 PM</div>
                  </div>
                  <h4 className="timeline-title">Rest & Reflection</h4>
                  <p className="timeline-description">Early sleep after evening prayers for 8 hours rest</p>
                </div>
                <div className="timeline-dot"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Common Questions Section */}
      <section className="common-questions-section">
        <div className="container">
          <div className="common-questions-content">
            <div className="questions-header">
              <div className="questions-left">
                <h2 className="questions-title">Frequently Ask Questions</h2>
              </div>
              <div className="questions-right">
                <h3 className="questions-subtitle">Get quick answers to the most frequently asked questions about gurukul education</h3>
              </div>
            </div>
            
            <div className="questions-list">
              {faqData.map((faq) => (
                <div key={faq.id} className={`question-item ${openFAQ === faq.id ? 'active' : ''}`}>
                  <div className="question-header" onClick={() => toggleFAQ(faq.id)}>
                    <div className="question-text">{faq.question}</div>
                    <div className={`question-icon ${openFAQ === faq.id ? 'rotated' : ''}`}>
                      <img src={arrowUpIcon} alt="Expand" />
                    </div>
                  </div>
                  <div className={`question-answer ${openFAQ === faq.id ? 'show' : ''}`}>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      
            <Contact />

    </div>
  );
};

export default VedaGurukulam;